import React from "react";
import ProjectCard from "./ProjectCard";
import { motion } from "framer-motion";

const cardVariants = {
  hover: {
    boxShadow: "0px 7px 29px 0px rgba(100, 100, 111, 0.2)",
    scale: 1.05,
    transition: {
      duration: 0.4,
    },
  },
};

const Project = () => {
  return (
    <div className="min-h-screen mb-3 max-w-6xl mx-auto" id="projects">
      <h2 className="md:text-8xl my-16 text-6xl mb-10 text-center md:text-right font-bold text-transparent bg-clip-text bg-gradient-to-r from-[#DD2476] via-[#FB680B] to-[#FF522C]">
        Projects
      </h2>

      <div className="grid md:grid-cols-6 grid-cols-1 gap-2  p-3">
        <motion.div
          variants={cardVariants}
          whileHover="hover"
          className="col-span-2 h-full w-full overflow-hidden"
        >
          <ProjectCard
            title="FundChain"
            link="https://github.com/jatin-02/FundChain"
            imgSrc="./assets/images/Project-1.png"
          />
        </motion.div>

        <motion.div
          variants={cardVariants}
          whileHover="hover"
          className="row-span-2 col-span-2 w-full overflow-hidden"
        >
          <ProjectCard
            title="Book Store"
            link="https://github.com/jatin-02/Book-Store"
            imgSrc="./assets/images/Project-2.jpg"
          />
        </motion.div>

        <motion.div
          variants={cardVariants}
          whileHover="hover"
          className="col-span-2 h-full w-full overflow-hidden"
        >
          <ProjectCard
            title="VR-SolarSystem"
            link="https://github.com/jatin-02/VR-SolarSystem"
            imgSrc="./assets/images/Project-3.png"
          />
        </motion.div>

        <motion.div
          variants={cardVariants}
          whileHover="hover"
          className="col-span-2 h-full w-full overflow-hidden"
        >
          <ProjectCard
            title="Research it"
            link="https://research-it.netlify.app/"
            imgSrc="./assets/images/Project-4.png"
          />
        </motion.div>

        <motion.div
          variants={cardVariants}
          whileHover="hover"
          className="col-span-2 h-full w-full overflow-hidden"
        >
          <ProjectCard
            title="E-Commerce Store"
            link="https://github.com/jatin-02/Ecommerce-Store"
            imgSrc="./assets/images/Project-5.png"
          />
        </motion.div>

        {/* <motion.div
          variants={cardVariants}
          whileHover="hover"
          className="col-span-3 h-full w-full overflow-hidden"
        >
          <ProjectCard
            title="Wordpress website"
            link="https://spieldeals.com/"
            imgSrc="./assets/images/Project-6.png"
          />
        </motion.div>

        <motion.div
          variants={cardVariants}
          whileHover="hover"
          className="col-span-3 h-full w-full overflow-hidden"
        >
          <ProjectCard
            title="Movie App"
            link="https://react-movie-app-gqx20d5nx-theviralboy.vercel.app/"
            imgSrc="./assets/images/Project-7.png"
          />
        </motion.div> */}
      </div>
    </div>
  );
};

export default Project;
